import { addDays, addMonths, addWeeks, endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";

const getDefaultRanges = (date) => [
  {
    label: "Aujourd'hui",
    startDate: date,
    endDate: date,
  },
  {
    label: "Hier",
    startDate: addDays(date, -1),
    endDate: addDays(date, -1),
  },
  {
    label: "Cette semaine",
    startDate: startOfWeek(date, { weekStartsOn: 1 }),
    endDate: endOfWeek(date, { weekStartsOn: 1 }),
  },
  {
    label: "Semaine dernière",
    startDate: startOfWeek(addWeeks(date, -1), { weekStartsOn: 1 }),
    endDate: endOfWeek(addWeeks(date, -1), { weekStartsOn: 1 }),
  },
  {
    label: "7 derniers jours",
    startDate: addWeeks(date, -1),
    endDate: date,
  },
  {
    label: "Ce mois-ci",
    startDate: startOfMonth(date),
    endDate: endOfMonth(date),
  },
  {
    label: "Mois dernier",
    startDate: startOfMonth(addMonths(date, -1)),
    endDate: endOfMonth(addMonths(date, -1)),
  },
];

export const defaultRanges = getDefaultRanges(new Date());
